/* eslint func-style: "off" */

import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  REQUEST_FORGOTTEN_CREDENTIALS,
  requestForgottenCredentialSuccess,
  requestForgottenCredentialFail
} from './ForgotCredentials.ducks';
import apiClient from 'helpers/apiClient';

const requestForgottenCredentials = function* (action) {
  const { email, credentialType } = action.payload;
  try {
    yield call(apiClient, '/auth/forgot/' + credentialType, {
      method: 'POST',
      body: JSON.stringify({ email })
    });
    yield put(requestForgottenCredentialSuccess());
  } catch (e) {
    if (e.body.error === 'User does not exist') {
      yield put(requestForgottenCredentialSuccess());
    } else {
      yield put(requestForgottenCredentialFail());
    }
  }
};

const forgotCredentialsSaga = function* () {
  yield takeLatest( REQUEST_FORGOTTEN_CREDENTIALS, requestForgottenCredentials);
};

const sagas = function* () {
  yield all([
    fork(forgotCredentialsSaga)
  ]);
};

export default sagas;
export { requestForgottenCredentials, forgotCredentialsSaga };
